import { LogoIcon } from "@/components/shared/logo";
import { cn } from "@/lib/utils";

type PersonaLoaderProps = {
  className?: string;
  size?: number;
  label?: string;
};

export function PersonaLoader({
  className,
  size = 48,
  label = "Loading",
}: PersonaLoaderProps) {
  return (
    <div
      className={cn(
        "fixed inset-0 z-50 flex items-center justify-center",
        className,
      )}
    >
      <div className="persona-loader-shell flex items-center justify-center">
        <LogoIcon size={size} className="persona-loader-icon" />
        <span className="sr-only">{label}</span>
      </div>
    </div>
  );
}
